import React from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';
import { useHistory, Link } from 'react-router-dom';

const Banner2 = () => {
  const { t, i18n } = useTranslation();
  let history = useHistory();

  const goToBooks = () => {
    history.push('/books');
  };

  const goToINAPI = () => {
    window.open('https://www.inapi.dz', '_blank');
  };

  const goToArabicCouncil = () => {
    history.push('/publications/council-books');
  };

  const goToUniversityResources = () => {
    history.push('/publications');
  };

  return (
    <div className="banner2-container">
      <div className="banner2-overlay"></div>
      <div className="container d-flex justify-content-center align-items-center w-100">
        <div className="banner-content">
          <div className="banner-title">
            {t('banner2.title1')}
          </div>
          <div className="banner-subtitle">
            <span className="clickable-content" onClick={goToINAPI}>
              {t('banner2.inapi')}
            </span>
            , 
            <span className="clickable-content" onClick={goToArabicCouncil}>
              {t('banner2.arabicCouncil')}
            </span>
            , 
            <span className="clickable-content" onClick={goToUniversityResources}>
              {t('banner2.universityResources')}
            </span>
            {' '}{t('banner2.andMore')}
          </div>
          <div className="banner-actions">
            <button className="banner-button" onClick={goToBooks}>
              {t('banner2.more')}
            </button>
            <Link to="/app" className="banner-button banner-button-app">
              {t('banner2.downloadApp')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner2;
